<script module>
  export const meta = {
    title: 'Plans & billing',
    teaser:
      "Our pricing model is simple and affordable, designed for ease. Here, you'll find\nclear details on our plans, tailored to offer value and keep costs low.",
    sort: 4,
  }
</script>
